// src/components/proposals/docTypes.js
//
// The Proposal-vs-Lead discriminator, and nothing else.
//
// It lives in its own file rather than in templateDefaults.js because
// opportunityPipeline.js needs it, and templateDefaults imports BronzeTemplate
// — importing it there would drag React into a module that is deliberately
// React-free so the pipeline colour rules stay unit-testable without rendering
// anything. templateDefaults re-exports everything below, so existing callers
// keep their import path.
//
// `docType` is deliberately SEPARATE from `templateKey`, which exists purely to
// route to a React component: two Lead variants would share a docType and not a
// templateKey, and adding a Silver proposal adds a templateKey and not a
// docType.

export const DOC_PROPOSAL = "proposal";
export const DOC_LEAD     = "lead";

/* THE ONLY WAY TO READ A RECORD'S DOCUMENT TYPE.

   Everything created before Leads existed has no `docType` field at all, so
   absence means "proposal". Never test the raw field — `p.docType === "proposal"`
   is FALSE for every record already sitting in a state blob, which is precisely
   the bug that would make every existing proposal stop counting toward its
   opportunity's colour. Same shape of trap as `opportunity.status`. */
export const docTypeOf = (record) =>
  record?.docType === DOC_LEAD ? DOC_LEAD : DOC_PROPOSAL;

export const isLead = (record) => docTypeOf(record) === DOC_LEAD;
